import { GET_TENANT_FINANCIALS, GET_TENANT_PAYMENT } from "../../actions/actionTypes";

export const tenantFinancialsReducer = (state={}, action) => {
    switch(action.type){
        case GET_TENANT_FINANCIALS:
            return action.payload;
        default:
            return state;
        
    }
}

export const tenantPaymentReducer = (state={}, action) => {
    switch(action.type){
        case GET_TENANT_PAYMENT:
            return action.payload.payment;
        default:
            return state;
        
    }
}